import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeSimColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangeSim } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const UltraChangeSimBatch = () => (
  <BatchDetail
    title="Change SIM"
    apiGet={__getChangeSim}
    client={CLIENTS.ultra}
    columnsFactory={changeSimColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_sim"
    retryOperation="change_sim"
    showTerminate
    getRowPath={(row) => `/ultra/change_sim/${row.id}`}
  />
);

export default UltraChangeSimBatch;
